export const isMobileDevice = () => {
  // 1. 用户代理检测（基础判断）
  const userAgent = navigator.userAgent?.toLowerCase()  || '';
  const mobileRegex = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // 2. 屏幕特性检测（辅助判断）
  const screenWidth = window.screen?.width  || 0;
  const isSmallScreen = screenWidth <= 768;
 
  // 组合判断逻辑 
  return (
    mobileRegex.test(userAgent)  ||
    isSmallScreen
  );
};